import { render, staticRenderFns } from "./EditInactivity.vue?vue&type=template&id=67ff073a&scoped=true&"
import script from "./EditInactivity.vue?vue&type=script&lang=ts&"
export * from "./EditInactivity.vue?vue&type=script&lang=ts&"
import style0 from "./EditInactivity.vue?vue&type=style&index=0&id=67ff073a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff073a",
  null
  
)

export default component.exports